import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

export const getTranscriptTimestamp = (timestamp1: number, timestamp2: number) => {
    dayjs.extend(duration);
    const diff = dayjs.duration(dayjs(timestamp2, "x").diff(dayjs(timestamp1, "x"))).format("HH:mm:ss");
    if (diff.startsWith("00:")) return diff.slice(3);

    return diff;
};
